namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeSerialRow {
        Id?: number;
        DiscCouponType?: string;
        Serial?: string;
        CreateBy?: string;
        CreateDate?: string;
        Used?: number;
        IsActive?: number;
    }

    export namespace PsDiscCouponTypeSerialRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DiscCouponType';
        export const localTextPrefix = 'InitialData.PsDiscCouponTypeSerial';
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';

        export declare const enum Fields {
            Id = "Id",
            DiscCouponType = "DiscCouponType",
            Serial = "Serial",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            Used = "Used",
            IsActive = "IsActive"
        }
    }
}
